import { phone } from "@/constants/config"

export default () => {
  window.location.href = `tel:${phone}`
}